<script>
  export default {
    methods: {
      close () {
        this.$refs.modal.close()
      }
    }
  }
</script>
